<div class="main-div">
  <h5 class="jack-title">{{ "jackpot-trigger-popup.title" | translate}}</h5>
  @if (jackpotPopupData?.image) {
    <div class="tri-div">
      <img src="../../../../assets/icon{{ jackpotPopupData?.image }}" alt="" class="trigger-img" />
    </div>
  }
  <p class="boost">{{ "jackpot-trigger-popup.description_1" | translate}}</p>
  <p class="or">{{ "jackpot-trigger-popup.or" | translate}}</p>
  <p class="big-draw">{{ "jackpot-trigger-popup.description_2" | translate}}</p>
  <div class="btn">
    <button class="act-btn" (click)="goToSyndicate()">{{ "jackpot-trigger-popup.button_label" | translate}}</button>
  </div>
</div>
